module.exports = __webpack_public_path__ + "img/pl.6ac4018b.svg";